"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _isBetween = _interopRequireDefault(require("dayjs/plugin/isBetween"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dayjs["default"].extend(_isBetween["default"]);

var isDayBetween = function isDayBetween(startBoundary, endBoundary, day) {
  return (0, _dayjs["default"])(day).startOf('day').isBetween((0, _dayjs["default"])(startBoundary).startOf('day'), (0, _dayjs["default"])(endBoundary).startOf('day'), undefined, '[]');
};

var _default = isDayBetween;
exports["default"] = _default;